import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

import * as Yup from 'yup'
import { useFormik } from 'formik'

import Layout from '../Layout/Layout'

// import { useNavigate } from "react-router-dom";
// import { useAuth0 } from "@auth0/auth0-react";
// import { addCompany } from "../../services/CompaniesService";
import SelectUserCompany from './SelectUserCompany'

const CrearUsuario = () => {
  const { t } = useTranslation('usuarios')

  const types = [
    { id: 1, value: '1', label: t('roles.basico') },
    { id: 2, value: '2', label: t('roles.clienteAdministrador') },
    { id: 3, value: '3', label: t('roles.bdoAdministrador') },
    { id: 4, value: '4', label: t('roles.clienteBasico') },
    { id: 5, value: '5', label: t('roles.bdoBasico') },
    { id: 6, value: '6', label: t('roles.bdoGerente') },
    { id: 7, value: '7', label: t('roles.bdoLectura') },
  ]

  // const navigate = useNavigate();

  // const { getAccessTokenSilently } = useAuth0();

  const formik = useFormik({
    initialValues: {
      name: '',
      lastname: '',
      email: '',
      type: '',
      phone: '',
      username: '',
      companies: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().max(55).required(t('crear.validation.nameRequired')),
      username: Yup.string()
        .max(55)
        .required(t('crear.validation.usernameRequired')),
      email: Yup.string().max(255).required(t('crear.validation.emailRequired')),
      phone: Yup.string().max(15).required(t('crear.validation.phoneRequired')),
      type: Yup.string().max(255).required(t('crear.validation.typeRequired')),
      companies: Yup.array()
        .min(1, t('crear.validation.companiesRequired'))
        .required(t('crear.validation.companiesRequired')),
    }),
    onSubmit: async datax => {
      // const token = await getAccessTokenSilently();
      // const result = await addCompany(token, data);
      // formik.resetForm();
      // console.log("submit - add", result);
      // if (result.status === 201) {
      //   navigate("/empresas");
      // }
    },
  })

  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${t('crear.pageTitle')}`
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout icon="PersonIcon" title={t('crear.pageTitle')}>
      <Grid container marginTop="12px" borderRadius="6px">
        <Grid bgcolor="white" item xs={10} borderRadius="6px">
          <Box
            sx={{
              borderRadius: '6px',
              display: 'flex',
              backgroundColor: 'white',
              height: '100%',
              width: '100%',
              paddingRight: '18px',
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <Box
                component="form"
                id="crear-usuario-form"
                autoComplete="off"
                borderRadius="6px"
                sx={{ backgroundColor: 'white', height: '100%' }}
                onSubmit={formik.handleSubmit}
              >
                <Grid container>
                  <Grid bgcolor="white" item xs={6}>
                    <Grid container>
                      <Grid item xs={6} sx={{ py: '10px', pl: '18px' }}>
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          marginBottom="4px"
                        >
                          <InputLabel sx={{ color: 'black' }} htmlFor="usuario-input">
                            {t('crear.fields.username')}
                          </InputLabel>
                        </Box>
                        <TextField
                          id="usuario-input"
                          error={Boolean(
                            formik.touched.username && formik.errors.username,
                          )}
                          fullWidth
                          helperText={formik.touched.username && formik.errors.username}
                          name="username"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.username}
                          variant="filled"
                          placeholder={t('crear.fields.usernamePlaceholder')}
                          InputProps={{
                            disableUnderline: true,
                            sx: {
                              borderRadius: '6px',
                              '.MuiInputBase-input': {
                                paddingBottom: '16px',
                                paddingTop: '16px',
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ py: '10px', pl: '18px' }}>
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          marginBottom="4px"
                        >
                          <InputLabel sx={{ color: 'black' }} htmlFor="email-input">
                            {t('crear.fields.email')}
                          </InputLabel>
                        </Box>
                        <TextField
                          id="email-input"
                          error={Boolean(formik.touched.email && formik.errors.email)}
                          fullWidth
                          helperText={formik.touched.email && formik.errors.email}
                          name="email"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="email"
                          value={formik.values.email}
                          variant="filled"
                          placeholder="info@bglobalsolutions.com"
                          InputProps={{
                            disableUnderline: true,
                            sx: {
                              borderRadius: '6px',
                              '.MuiInputBase-input': {
                                paddingBottom: '16px',
                                paddingTop: '16px',
                              },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={6} sx={{ py: '10px', pl: '18px' }}>
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          marginBottom="4px"
                        >
                          <InputLabel sx={{ color: 'black' }} htmlFor="nombre-input">
                            {t('crear.fields.name')}
                          </InputLabel>
                        </Box>
                        <TextField
                          id="nombre-input"
                          error={Boolean(formik.touched.name && formik.errors.name)}
                          fullWidth
                          helperText={formik.touched.name && formik.errors.name}
                          name="name"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.name}
                          variant="filled"
                          placeholder={t('crear.fields.name')}
                          InputProps={{
                            disableUnderline: true,
                            sx: {
                              borderRadius: '6px',
                              '.MuiInputBase-input': {
                                paddingBottom: '16px',
                                paddingTop: '16px',
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ py: '10px', pl: '18px' }}>
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          marginBottom="4px"
                        >
                          <InputLabel sx={{ color: 'black' }} htmlFor="apellido-input">
                            {t('crear.fields.lastName')}
                          </InputLabel>
                        </Box>
                        <TextField
                          id="apellido-input"
                          error={Boolean(
                            formik.touched.lastname && formik.errors.lastname,
                          )}
                          fullWidth
                          helperText={formik.touched.lastname && formik.errors.lastname}
                          name="lastname"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.lastname}
                          variant="filled"
                          placeholder={t('crear.fields.lastName')}
                          InputProps={{
                            disableUnderline: true,
                            sx: {
                              borderRadius: '6px',
                              '.MuiInputBase-input': {
                                paddingBottom: '16px',
                                paddingTop: '16px',
                              },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={6} sx={{ py: '10px', pl: '18px' }}>
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          marginBottom="4px"
                        >
                          <InputLabel sx={{ color: 'black' }} htmlFor="phone-input">
                            {t('crear.fields.phone')}
                          </InputLabel>
                        </Box>
                        <TextField
                          id="phone-input"
                          error={Boolean(formik.touched.phone && formik.errors.phone)}
                          fullWidth
                          helperText={formik.touched.phone && formik.errors.phone}
                          name="phone"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                          value={formik.values.phone}
                          variant="filled"
                          placeholder="+5412345678"
                          InputProps={{
                            disableUnderline: true,
                            sx: {
                              borderRadius: '6px',
                              '.MuiInputBase-input': {
                                paddingBottom: '16px',
                                paddingTop: '16px',
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ py: '10px', pl: '18px' }}>
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          marginBottom="4px"
                        >
                          <InputLabel sx={{ color: 'black' }} htmlFor="tipo-select">
                            {t('crear.fields.type')}
                          </InputLabel>
                        </Box>
                        <TextField
                          id="tipo-select"
                          select
                          error={Boolean(formik.touched.type && formik.errors.type)}
                          fullWidth
                          helperText={formik.touched.type && formik.errors.type}
                          name="type"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.type}
                          variant="filled"
                          InputProps={{
                            disableUnderline: true,
                            sx: {
                              borderRadius: '6px',
                              '.MuiInputBase-input': {
                                paddingBottom: '16px',
                                paddingTop: '16px',
                                display: 'flex',
                                justifyContent: 'flex-start',
                              },
                            },
                          }}
                        >
                          {types.map(type => (
                            <MenuItem key={type.id} value={type.value}>
                              {type.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid bgcolor="white" item xs={6}>
                    <Grid container>
                      <Grid item xs={12} sx={{ py: '10px', pl: '18px' }}>
                        <Box
                          display="flex"
                          justifyContent="flex-start"
                          marginBottom="4px"
                        >
                          <InputLabel sx={{ color: 'black' }} htmlFor="status-select">
                            {t('crear.fields.assignCompany')}
                          </InputLabel>
                        </Box>
                        <SelectUserCompany
                          actualState={formik.values}
                          onChange={formik.setValues}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container maxWidth="sm" paddingBottom="32px" paddingTop="32px">
                  <Button
                    sx={{ marginLeft: '18px' }}
                    variant="contained"
                    color="primary"
                    form="crear-usuario-form"
                    type="submit"
                    disabled={
                      !formik.dirty ||
                      !formik.values.email ||
                      !formik.values.name ||
                      !formik.values.companies ||
                      !formik.values.type
                    }
                  >
                    {t('crear.fields.save')}
                  </Button>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Layout>
  )
}

export default CrearUsuario
